
var deepClone = function f (obj) {
  if (obj === null) return null;
  if (typeof obj !== 'object') return obj;
  if (obj.constructor === Date) return new Date(obj);
  if (obj.constructor === RegExp) return new RegExp(obj);
  var newObj = new obj.constructor(); // 保持继承链
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      // 不遍历其原型链上的属性
      var val = obj[key];
      newObj[key] = typeof val === 'object' ? f(val) : val; // 使用arguments.callee解除与函数名的耦合
    }
  }
  return newObj;
};
function getQueryParams (url) {
  url = url || location.href
  const splitList = url.split('?')
  url = splitList[1] || ''
  const params = url
    .split('&')
    .filter(Boolean)
    .reduce((obj, item) => {
      const [key, value] = item.split('=')
      const val = decodeURIComponent(value)
      if (Array.isArray(obj[key])) {
        obj[key].push(val)
      } else if (typeof obj[key] === 'string') {
        obj[key] = [obj[key], val]
      } else {
        obj[key] = val
      }
      return obj
    }, {})
  return params
}

function formatDate (date, split = '-') {
  const newDate = new Date(date);
  let y = newDate.getFullYear();
  let m = newDate.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = newDate.getDate();
  d = d < 10 ? '0' + d : d;
  return y + `${split}` + m + `${split}` + d;
}

function formatMonth (date) {
  const newDate = new Date(date);
  let y = newDate.getFullYear();
  let m = newDate.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = newDate.getDate();
  d = d < 10 ? '0' + d : d;
  return y + '-' + m;
}

function toggleAllScreen () {
  /* 判断是否全屏 */
  var isFullscreen =
    document.fullScreenElement || // W3C
    document.msFullscreenElement || // IE
    document.mozFullScreenElement || // 火狐
    document.webkitFullscreenElement || // 谷歌
    false;
  if (!isFullscreen) {
    var el = document.documentElement;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
}

function getMonthLastDay (date) {
  const newDate = new Date(date);
  let y = newDate.getFullYear();
  let m = newDate.getMonth() + 1;
  return formatDate(new Date(y, m, 0));
}

function debounce (func, wait) {
  let timer;
  return function () {
    let context = this; // 注意 this 指向
    let args = arguments; // arguments中存着e

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

function getCookie (name) {
  var start = document.cookie.indexOf(name + '=');
  var len = start + name.length + 1;
  if (!start && name != document.cookie.substring(0, name.length)) {
    return null;
  }
  if (start == -1) return null;
  var end = document.cookie.indexOf(';', len);
  if (end == -1) end = document.cookie.length;
  return unescape(document.cookie.substring(len, end));
}

function setCookie (name, value, expires) {
  var today = new Date();
  today.setTime(today.getTime());
  if (expires) {
    expires = expires * 1000 * 60 * 60 * 24;
  }
  var expiresDate = new Date(today.getTime() + expires);
  document.cookie = name + '=' + escape(value) + (expires ? ';expires=' + expiresDate.toGMTString() : '') + '; path=/'; // expires.toGMTString()
}

function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
}

var DateMap = new Map();
DateMap.set('data-auto', (beginTime, lastTime) => {
  return 'dataAuto';
});
DateMap.set('data-today', (beginTime, lastTime) => { });
DateMap.set('data-yestoday', (beginTime, lastTime) => {
  beginTime.setTime(new Date().getTime() - 24 * 1000 * 60 * 60);
  lastTime.setTime(new Date().getTime() - 24 * 1000 * 60 * 60);
});
DateMap.set('data-monthDate-yestoday', (beginTime, lastTime) => {
  beginTime.setDate(1);
  if (new Date().getDate() === 1) {
    lastTime.setTime(new Date().getTime());
  } else {
    lastTime.setTime(new Date().getTime() - 24 * 1000 * 60 * 60);
  }
});
DateMap.set('data-monthDate-today', (beginTime, lastTime) => {
  beginTime.setDate(1);
});
DateMap.set('data-recentday', (beginTime, lastTime, recentNum) => {
  beginTime.setTime(new Date().getTime() - (recentNum - 1) * 24 * 1000 * 60 * 60);
  lastTime.setTime(new Date());
});
DateMap.set('data-recentday-notoday', (beginTime, lastTime, recentNum) => {
  beginTime.setTime(new Date().getTime() - recentNum * 24 * 1000 * 60 * 60);
  lastTime.setTime(new Date().getTime() - 24 * 1000 * 60 * 60);
});
DateMap.set('data-frontday', (beginTime, lastTime, recentNum) => {
  beginTime.setTime(new Date().getTime() - recentNum * 24 * 1000 * 60 * 60);
  lastTime.setTime(new Date().getTime() - recentNum * 24 * 1000 * 60 * 60);
});
// DateMap.set('data-3day', (beginTime, lastTime) => {
//     beginTime.setTime(
//         new Date().getTime() - 2 * 24 * 1000 * 60 * 60
//     );
//     lastTime.setTime(new Date());
// })
// DateMap.set('data-7day', (beginTime, lastTime) => {
//     beginTime.setTime(
//         new Date().getTime() - 6 * 24 * 1000 * 60 * 60
//     );
//     lastTime.setTime(new Date());
// })
// DateMap.set('data-30day', (beginTime, lastTime) => {
//     beginTime.setTime(
//         new Date().getTime() - 29 * 24 * 1000 * 60 * 60
//     );
//     lastTime.setTime(new Date());
// })
// DateMap.set('data-90day', (beginTime, lastTime) => {
//     beginTime.setTime(
//         new Date().getTime() - 89 * 24 * 1000 * 60 * 60
//     );
//     lastTime.setTime(new Date());
// })

class TooltipsObj {
  constructor() {
    try {
      const objWrap = document.createElement('div');
      const objArrow = document.createElement('div');
      const objContent = document.createElement('div');
      const objContentWrap = document.createElement('div');
      objWrap.className = 'zztooltipsWrap';
      objArrow.className = 'zztooltipsArrow';
      objContent.className = 'zztooltipsContent';
      objContentWrap.className = 'zztooltipsContentWrap';
      this.objWrap = objWrap;
      this.objContent = objContent;
      // 记录上次监听的对象
      this.lastAddlistenterDom = null;
      document.querySelector('body').appendChild(this.objWrap);
      const styleObj = {
        position: 'fixed',
        display: 'none',
        zIndex: '1000',
        paddingLeft: '5px',
        transition: 'all 200ms linear',
      };
      const styleContentWrap = {
        background: 'rgb(88,93,107)',
        padding: '10px',
      };
      const styleArrow = {
        position: 'absolute',
        width: 0,
        height: 0,
        borderColor: 'transparent',
        borderStyle: 'solid',
        top: '50%',
        marginTop: '-5px',
        borderWidth: '5px 5px 5px 0',
        borderRightColor: 'rgba(70, 76, 91, 0.9)',
        left: 0,
      };
      const styleContent = {
        background: '#fff',
      };
      Object.entries(styleObj).map((v) => {
        this.objWrap.style[v[0]] = v[1];
      });
      Object.entries(styleArrow).map((v) => {
        objArrow.style[v[0]] = v[1];
      });
      Object.entries(styleContent).map((v) => {
        objContent.style[v[0]] = v[1];
      });
      Object.entries(styleContentWrap).map((v) => {
        objContentWrap.style[v[0]] = v[1];
      });
      this.objWrap.addEventListener('mouseleave', (e) => {
        e.target.style.display = 'none';
      });
      this.objWrap.appendChild(objArrow);
      objContentWrap.appendChild(objContent);
      this.objWrap.appendChild(objContentWrap);
    } catch (e) { }
  }

  setTooltipsDom (originDom, insertDom) {
    if (this.lastAddlistenterDom) {
      this.lastAddlistenterDom.removeEventListener('mouseleave', this.mouseleaveListenter);
    }
    this.lastAddlistenterDom = originDom;
    this.lastAddlistenterDom.addEventListener('mouseleave', this.mouseleaveListenter, false);
    this.objWrap.style.display = 'block';
    this.objContent.innerHTML = insertDom;
    this.objWrap.style.opacity = 0;
    setTimeout(() => {
      const styleData = {
        top: originDom.getBoundingClientRect().top - this.objContent.clientHeight / 2 + 'px',
        left: originDom.getBoundingClientRect().left + originDom.clientWidth + 'px',
        opacity: 1,
      };
      Object.entries(styleData).map((v) => {
        this.objWrap.style[v[0]] = v[1];
      });
    }, 20);
  }

  mouseleaveListenter (e) {
    if (!e.relatedTarget.className.includes('zztooltips')) {
      document.querySelector('.zztooltipsWrap').style.display = 'none';
    }
  }
}

function getBeginEndStr (str, startStr, endStr) {
  const matchLength = str.match(eval('/' + startStr + '/g')).length;
  const attr = [];
  let fromIndex = 0;
  for (let i = 0; i < matchLength; i++) {
    let beginIndex = str.indexOf(startStr, fromIndex);
    let endIndex = str.indexOf(endStr, beginIndex);
    fromIndex = endIndex;
    attr.push(str.substring(beginIndex + startStr.length, endIndex));
  }
  return attr;
}

function formatThousandMark (value) {
  let curValue = String(value).replace(/\$|\%/g, '');
  const fuValue = String(value).indexOf('-') == 0;
  const dollarIndex = String(value).includes('$');
  const percentIndex = String(value).includes('%');
  if (Number(curValue)) {
    if (fuValue) {
      curValue = curValue.substring(1, 1000);
    }
    const str = String(curValue);
    if (Number(curValue) >= 1000) {
      let intLength = str.indexOf('.') != -1 ? str.indexOf('.') : str.length;
      let deciStr = str.substring(intLength, 1000);
      let attrReverse = str
        .split('')
        .slice(0, intLength)
        .reverse();
      for (let i = attrReverse.length - 2; i >= 0; i--) {
        if ((i + 1) % 3 === 0) {
          attrReverse.splice(i + 1, 0, ',');
        }
      }
      return dollarIndex ? '$' + attrReverse.reverse().join('') + deciStr : percentIndex ? attrReverse.reverse().join('') + deciStr + '%' : fuValue ? '-' + attrReverse.reverse().join('') + deciStr : attrReverse.reverse().join('') + deciStr;
      // while()
    } else {
      return value;
    }
  } else {
    return value;
  }
}

function getQuery (paraName) {
  var url = document.location.toString().replace('/#', '');
  var arrObj = url.split('?');

  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&');
    var arr;

    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=');

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return '';
  } else {
    return '';
  }
}

function getweek (z) {
  // 参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
  let day = Date.parse(z);
  let day11 = new Date(day);
  day11.setMonth(0);
  day11.setDate(1);
  day11.setHours(0);
  day11.setMinutes(0);
  day11.setSeconds(0); // 到这里就得到该年的一月一日

  let day11mill = day11.getTime();
  let oriDay = day11.getDay(); // 该年的一月一日是星期几
  let fill1 = 0; // 与星期日相隔的毫秒数
  if (oriDay !== 0) {
    fill1 = oriDay * 60 * 60 * 24 * 1000;
  }

  let now = Date.parse(z);
  now = new Date(now);
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  let nowmill = now.getTime();
  let nowDay = now.getDay();
  let fill2 = 0;
  if (nowDay !== 0) {
    fill2 = (7 - nowDay) * 60 * 60 * 24 * 1000;
  }

  let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
  let week = Math.ceil(cha2 / 7);
  if (week < 10) {
    week = '0' + week;
  }
  let year = now.getFullYear().toString();
  year = year.substring(2);
  return week;
}

function getDate (data = new Date(), index, splitStr = '', hasTime = false) {
  var date = new Date(data); // 当前日期
  var newDate = new Date(data);
  newDate.setDate(date.getDate() + index); // 官方文档上虽然说setDate参数是1-31,其实是可以设置负数的
  var time = `${newDate.getFullYear()}${splitStr}${newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1}${splitStr}${newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()}${hasTime ? ' 00:00:00' : ''}`;
  return time;
}
function getMondayAndSunday (date) {
  const now = new Date(date);
  const nowTime = now.getTime();
  let day = now.getDay();
  if (day == 0) {
    day = 7;
  }
  const oneDayTime = 24 * 60 * 60 * 1000;
  const MondayTime = formatDate(nowTime - (day - 1) * oneDayTime, ''); // 显示周一
  const SundayTime = formatDate(nowTime + (7 - day) * oneDayTime, ''); // 显示周日
  return [MondayTime, SundayTime];
}

const os = () => {
  const ua = navigator.userAgent
  const isWindowsPhone = /(?:Windows Phone)/.test(ua)
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  const isAndroid = /(?:Android)/.test(ua)
  const isFireFox = /(?:Firefox)/.test(ua)
  const isChrome = /(?:Chrome|CriOS)/.test(ua)
  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet
  const isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
    isChrome
  }
}

const filterVariant = value => {
  if (!value) return
  value = JSON.parse(value)
  let valueStr = ''
  for (let key in value) {
    valueStr += `,${key}:${value[key]}`
  }
  return valueStr
}

export { filterVariant, os, getweek, getDate, deepClone, formatDate, getCookie, setCookie, getQueryParams, delCookie, formatMonth, getMondayAndSunday, TooltipsObj, getMonthLastDay, DateMap, getBeginEndStr, toggleAllScreen, formatThousandMark, getQuery, debounce };
